declare let __APPVERSION__: string;

export const APPVERSION = __APPVERSION__;
